import axios from 'axios';
import API_URL from '../config';
import { axiosInterceptor } from './axios.interceptors';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export const intialConfig = axios.create({
    baseURL: API_URL.CREDENTIAL_API,
    timeout: 30000,
    cancelToken: source.token
});

const allInstance = {
    credential: axios.create({
        baseURL: API_URL.CREDENTIAL_API,
        timeout: 30000,
        cancelToken: source.token
    }),
    provision: axios.create({
        baseURL: API_URL.PROVISION_API,
        timeout: 300000,
        cancelToken: source.token
    }),
    stateFile: axios.create({
        baseURL: API_URL.STATEFILE_API,
        timeout: 300000,
        cancelToken: source.token
    }),
    stateFileImport: axios.create({
        baseURL: API_URL.STATEFILE_IMPORT_API,
        timeout: 1200000,
        cancelToken: source.token
    }),
}

for (const instance in allInstance) {
    axiosInterceptor(allInstance[instance])
}

export default allInstance;
